import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';



@Injectable()
export class UploadApiService {

    uploadURL: string = config.API_DATA_URL + '/upload';
    public uploadProgress: number;

    constructor(public http: HttpClient) {

    }

    upload(fileToUpload: any) {
        const input = new FormData();
        input.append('file', fileToUpload);

        return this.http
            .post(this.uploadURL, input);
    }

    deleteFile(id: number, ordenServicio: string, tipoFoto: string) {
        return this.http
            .delete(this.upload + '/' + id + '/' + ordenServicio + '/' + tipoFoto);
    }

    uploadFiles(file) {
        if (file.length === 0) {
            return;
        }

        const formData = new FormData();

        formData.append('file', file);
        // for (const file of files) {
        //     formData.append(file.name, file);
        // }

        const req = new HttpRequest('POST', this.uploadURL, formData, {
            reportProgress: true,
        });
        
        this.http.request(req).subscribe(event => {
            if (event.type === HttpEventType.UploadProgress) {
                this.uploadProgress = Math.round(100 * event.loaded / event.total);
            } else if (event instanceof HttpResponse) {
                console.log(event);
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/upload-api.service.ts